<template>
	<div class="prebet-match">
		<div class="time">
			<div class="pull-left" style="width: 70%; text-align: left">
				<span
					v-if="match.sport_name"
					style="display: flex; align-items: center"
				>
					<sport-icon
						:sport="{ sport_name: match.sport_name, sport_id: match.sport_id }"
						class="prebet-match__sport-icon"
					/>
					<span>
						{{
							`${match.category ? match.category + " • " : ""}${
								match.competition_name
							}` | truncate(30)
						}}
					</span>
				</span>
			</div>

			{{ match.start_time | betterTime }}
		</div>
		<div class="prebet-match__odd-market__container">
			<div class="prebet-match__teams">
				<span class="prebet-match__teams__home" @click="openMarkets('')">{{
					match.home_team | toTitleCase | truncate(17)
				}}</span>
				<span @click="openMarkets('')">{{
					match.away_team | toTitleCase | truncate(17)
				}}</span>
			</div>
			<div class="prebet-match__odds__container">
				<div
					v-if="match.odds"
					class="prebet-match__odds"
					:number-of-odds="odds.length"
				>
					<match-odd
						v-for="(odd, index) in odds"
						:key="index"
						:odd="odd"
						:match="match"
						:market="match.odds[0]"
					/>
				</div>

				<div
					v-else
					class="prebet-match__odds"
					:number-of-odds="blankOdds.length"
				>
					<match-odd
						v-for="(odd, index) in blankOdds"
						:key="index"
						:odd="odd"
						:match="blankOdds"
						:market="null"
					/>
				</div>
			</div>
		</div>
		<div class="prebet-match__bottom">
			<div class="prebet-match__markers">
				<!-- <b-marker style="margin-left: 5px" :label="`#${match.game_id}`" /> -->
				<cashout-match-indicator
					:competitionID="Number(match.competition_id)"
					:sportID="Number(match.sport_id)"
					:subTypeID="Number(selectedMarket.sub_type_id.split(',')[0])"
				/>
				<span
					style="color: #c00; font-size: var(--font-small); margin-left: 5px"
					v-show="upcoming"
					>Upcoming Live</span
				>
				<b-marker
					style="margin-left: 5px"
					:label="'esport'"
					:color="'rgb(155 118 222)'"
					:bg="'rgb(238 230 254)'"
					v-show="match.is_esport"
				/>
				<b-marker
					style="margin-left: 5px"
					:label="'srl'"
					:color="'rgb(155 118 222)'"
					:bg="'rgb(238 230 254)'"
					v-show="match.is_srl"
				/>
			</div>
			<a
				class="prebet-match__markets"
				:class="{ selected: isMyMatchSelected }"
				@click="openMarkets('')"
			>
				+{{ match.side_bets }} Markets
			</a>
		</div>
	</div>
</template>
<script>
import MatchOdd from "./MatchOdd.vue";
import store from "../../store";
import { betterTime } from "../../assets/scripts/helpers";
import CashoutMatchIndicator from "../Shared/CashoutMatchIndicator.vue";
export default {
	name: "prebet-match",
	props: ["match", "upcoming", "selectedMarket"],
	components: {
		MatchOdd,
		CashoutMatchIndicator,
	},
	computed: {
		blankOdds() {
			return this.selectedMarket.odd_keys.map((odd_key) => {
				return {
					display: odd_key,
					odd_key,
					odd_value: 0,
				};
			});
		},
		odds() {
			let vm = this;
			if (vm.match.odds && vm.match.odds[0]) {
				return vm.match.odds[0].odds.map((odd) => {
					odd.parent_match_id = vm.match.parent_match_id;
					odd.sport_id = vm.match.sport_id;
					return odd;
				});
			}
			return [];
		},
		isMyMatchSelected() {
			let vm = this;
			let myMatch = store.state.betSlip.filter(function (bet) {
				return (
					bet.matchId == vm.match.match_id && // my match
					vm.selectedMarket.sub_type_id.split(",").filter((s) => s == bet.type)
						.length == 0
				); // Don't show my current market
			});
			return myMatch.length > 0;
		},
	},
	methods: {
		openMarkets(tab = "") {
			if (tab == "statistics") {
				fbq("trackCustom", "clickPrebetsMatchStatsLink", {
					user_id: window.localStorage.getItem("user")
						? JSON.parse(window.localStorage.getItem("user")).id
						: "",
				});
			}
			this.$router.push({
				name: "prebet-markets",
				params: { matchId: this.match.match_id, tab: tab },
			});
		},
	},
	filters: {
		betterTime: betterTime,
	},
};
</script>
<style lang="scss">
.prebet-match {
	font-size: var(--font-medium);
	background-color: var(--white);
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	padding: 5px;

	&__sport-icon {
		height: 15px;
		width: 15px;
		fill: var(--light-black);
		margin-right: 2px;
	}
	.time {
		text-align: right;
		padding: 5px;
		color: var(--light-black);
		font-size: var(--font-small);
		font-weight: var(--font-weight-lighter);
	}
	.details {
		padding: 0 5px 5px 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: var(--light-black);
		font-size: var(--font-small);
	}
	&__teams {
		display: flex;
		flex-direction: column;
		padding: 2px 5px;
		flex-basis: 50%;
		font-weight: var(--font-weight-medium);
		text-transform: capitalize;
		font-size: var(--font-medium);
		color: var(--black);
		line-height: 12px;
		white-space: nowrap;
		cursor: pointer;
		&__home {
			margin-bottom: 8px;
		}
	}
	&__odd-market__container {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 5px 0;
	}
	&__odds {
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		flex: 10;
		&__container {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
			flex-basis: 50%;
		}
		&[number-of-odds="2"] {
			.prebet-match__odd {
				width: calc(50% - 4px);
			}
		}
		&[number-of-odds="3"] {
			.prebet-match__odd {
				width: calc(100% / 3 - 4px);
			}
		}
	}
	&__markets {
		font-weight: var(--font-weight-normal);
		font-size: var(--font-small);
		text-align: left;
		color: var(--green);
		padding: 5px 0;
		text-transform: capitalize;
		cursor: pointer;
		&.selected {
			color: var(--yellow);
		}
	}
	&__statistics {
		cursor: pointer;
	}
	&__bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	&__markers {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	&__odd {
	}
}
</style>
